module.exports = __webpack_public_path__ + "static/media/MobileFooter.aa240daf.png";